module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./YofouiDemoView.js"));
	}, "YofouiDemoView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=YofouiDemoView!./src/pages/Shop/Member/Personal/YofouiDemo/YofouiDemoView.js
// module id = 984
// module chunks = 438